import React, { createContext, useState, useContext } from "react";

// Creamos el contexto
const MenuContext = createContext();

// Hook para acceder fácilmente al contexto
export const useMenu = () => {
  return useContext(MenuContext);
};

// Proveedor del contexto
export const MenuProvider = ({ children }) => {
  const storedUserType = localStorage.getItem("user") || "{}";
  const initialMenus = JSON.parse(storedUserType)?.array_menus || [];
  const [array_menus, setArrayMenus] = useState(initialMenus);

  // Función para actualizar los menús tanto en el estado global como en localStorage
  const updateMenus = (newMenus) => {
    // Actualizamos en el estado global
    setArrayMenus(newMenus);
  };

  return (
    <MenuContext.Provider value={{ array_menus, updateMenus }}>
      {children}
    </MenuContext.Provider>
  );
};
